var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEllipse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 5,
    viewBox: "0 0 23 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000002911"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 1270",
    cx: 11.5,
    cy: 2.5,
    rx: 2.5,
    ry: 2.5,
    transform: "rotate(-180 11.5 2.5)",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 1272",
    cx: 2.5,
    cy: 2.5,
    rx: 2.5,
    ry: 2.5,
    transform: "rotate(-180 2.5 2.5)",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 1271",
    cx: 20.5,
    cy: 2.5,
    rx: 2.5,
    ry: 2.5,
    transform: "rotate(-180 20.5 2.5)",
    fill: "#666666"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse);
export default __webpack_public_path__ + "static/media/ellipse.10feea45d11a8db4b89ca616af9a8472.svg";
export { ForwardRef as ReactComponent };